import EmailPage from "./pages/EmailList";

import EmailView from "./pages/EmailView";
export default { EmailPage, EmailView };
